import React, { useEffect, useState } from 'react'
import { Input, Form, Col, Button, message, Table, Row, Tooltip } from 'antd'
import { EditOutlined, PlusOutlined } from '@ant-design/icons'
import apiRequest from '../hooks/ApiRequest'
import Layouts from '../components/Layouts'

const LapsPeriodForm = props => {
  const { form } = props
  const { getFieldDecorator, resetFields, validateFields } = form
  const [productList, setProductList] = useState([])
  const [showForm, setShowForm] = useState(false)
  const [editingId, setEditingId] = useState(null)

  const fetchProducts = async () => {
    try {
      const response = await apiRequest(
        `${process.env.REACT_APP_BASE_URL_ADMIN}/Product/GetAllLapsePeriods`,
        'GET'
      )

      if (response?.data?.success) {
        const lapsPeriods = response.data.data || []
        const arrayData = lapsPeriods.map(lp => ({
          key: lp.id,
          id: lp.id,
          lapsperiod: lp.lapsePeriod + ' Days'
        }))
        setProductList(arrayData)
      } else {
        message.warning(response?.data?.message || 'No lapse periods found!')
        setProductList([])
      }

    } catch (error) {
      console.error('Fetch Products Error:', error)
      message.error('Failed to fetch lapse period!')
    }
  }

  useEffect(() => {
    fetchProducts()
  }, [])

  const handleAdd = () => {
    setEditingId(null)
    setShowForm(true)
    resetFields()
  }

  const handleEdit = record => {
    const valueWithoutDays = record.lapsperiod.replace(' Days', '')
    setEditingId(record.id)
    setShowForm(true)
    setTimeout(() => {
      form.setFieldsValue({
        LapsePeriod: valueWithoutDays
      })
    }, 0)
  }

  const handleSubmit = async e => {
    e.preventDefault()
    try {
      const values = await validateFields()
      const { LapsePeriod } = values
      const userId = parseInt(localStorage.getItem('loggedInUserID'), 10) || 0

      let url = ''
      let body = {}

      if (editingId) {
        url = `${process.env.REACT_APP_BASE_URL_ADMIN}/Product/UpdateLapsePeriodById`
        body = {
          id: editingId,
          lapsePeriod: Number(LapsePeriod),
          isActive: true,
          updatedBy: userId
        }
      } else {
        url = `${process.env.REACT_APP_BASE_URL_ADMIN}/Product/CreateLapsePeriod`
        body = {
          insurerId: 0,
          lapsePeriod: Number(LapsePeriod),
          createdBy: userId,
          isActive: true,
          isDeleted: false
        }
      }

      const response = await apiRequest(url, 'POST', body)

      if (response?.data?.status === true) {
        message.success(response?.data?.message || (editingId ? 'Updated successfully!' : 'Added successfully!'))
        resetFields()
        setShowForm(false)
        fetchProducts()
      } else {
        message.error(response?.data?.message || 'Operation failed!')
      }

    } catch (error) {
      console.error('Submit Error:', error)
      message.error('Failed to save lapse period!')
    }
  }

  const columns = [
    {
      key: '1',
      title: 'Lapse Period',
      dataIndex: 'lapsperiod',
    },
    {
      key: '2',
      title: 'Action',
      render: (_, record) => (
        <Tooltip title="Edit">
          <Button type="primary" className="edit_btn" onClick={() => handleEdit(record)}>
            <EditOutlined />
          </Button>
        </Tooltip>
      ),
    },
  ]

  return (
    <Layouts>
      <div title="Manage Lapse Period" className="ant-layout-content dashboard">
        <div className="dash-bg-white">
          <Row gutter={[16, 16]} justify="space-between">
            <Col xs={24} md={12}>
              <div className="section-top-heading">
                <h3 style={{ color: '#0C1362', fontWeight: '600', fontSize: '20px' }}>
                  Manage Lapse Period
                </h3>
              </div>
            </Col>

            {/* Show Add button only if no records exist */}
            {productList.length === 0 && (
              <Col xs={24} md={12} style={{ textAlign: 'right' }}>
                <Button type="primary" onClick={handleAdd} icon={<PlusOutlined />}>
                  Add Lapse Period
                </Button>
              </Col>
            )}
          </Row>
        </div>

        <div>
          <Row className="m-t-30 m-b-40">
            {showForm && (
              <div className="dash-bg-white" style={{ padding: '20px', width: '100%' }}>
                <Form layout="vertical" onSubmit={handleSubmit}>
                  <Row gutter={[16, 0]}>
                    <Col xs={24} md={18}>
                      <Form.Item label="Lapse Period">
                        {getFieldDecorator('LapsePeriod', {
                          rules: [{ required: true, message: 'Please enter lapse period' }],
                        })(<Input placeholder="Enter Lapse Period" type='number' />)}
                      </Form.Item>
                    </Col>
                    <Col xs={24} md={6}>
                      <Button htmlType="submit" className="primary m-t-22">
                        {editingId ? 'Update Period' : 'Add Period'}
                      </Button>
                    </Col>
                  </Row>
                </Form>
              </div>
            )}

            <div className="table-grid-bx">
              <Table
                className="table-scroll-auto"
                columns={columns}
                dataSource={productList}
                pagination={false}
                rowKey="id"
              />
            </div>
          </Row>
        </div>
      </div>
    </Layouts>
  )
}

export default Form.create()(LapsPeriodForm)